import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaGithub,
  FaDiscord,
  FaTools
} from "react-icons/fa";
import { SiRoblox } from "react-icons/si";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>© 2025 Reiyn. All Rights Reserved</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Thank you for visiting!</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/iamreiyn"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://discord.com/users/262552056089280513"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaDiscord />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://devforum.roblox.com/u/iamrenisal/summary"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <SiRoblox />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
